import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { COOKIE_NAME_CURRENCY } from '../../constants'
import { useCookiesByStore } from '../../hooks/useCookiesByStore'
import { useCurrencyFormatter } from '../../hooks/useCurrencyFormatter'
import { useConfig } from '../config'

const CurrencyContext = createContext()

const CurrencyProvider = ({ children, currencyCode }) => {
	const { locale, displayCurrencies } = useConfig()

	const [, setCookiesByStore] = useCookiesByStore()
	const [currency, setCurrency] = useState(currencyCode)

	useEffect(() => {
		setCookiesByStore(COOKIE_NAME_CURRENCY, currency)
	}, [currency, setCookiesByStore])

	const formatter = useCurrencyFormatter(locale, {
		currency,
		currencyDisplay: displayCurrencies?.[currency]?.currencyDisplay,
	})

	const symbol =
		displayCurrencies?.[currency]?.customSymbol ||
		formatter.formatToParts(0).find(({ type }) => type === 'currency')?.value

	const value = useMemo(() => ({ currency, symbol, setCurrency }), [currency, symbol])

	return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>
}

export default CurrencyProvider
export const useCurrency = () => useContext(CurrencyContext)
